<footer class="footer-partial">
    <div class="content">  
        <div class="container">
            <div class="content-logo"> 
                <modulo posicao="logo-footer"></modulo>
            </div>   
            <div class="row">
                <div class="col-md-4">
                    <modulo posicao="endereco"></modulo>
                </div>
                <div class="col-md-5">
                    <modulo posicao="horarios-de-culto" template="two"></modulo> 
                </div>  
                <div class="col-md-3">
                    <menu-footer-partial></menu-footer-partial>
                </div>  
            </div>    
        </div>   
    </div>
    <div class="copy">
        <div class="container">
            <p>
                <span>© Greenhouse 2021 - Desenvolvido por</span>
                <a href="https://digitalmovement.com.br" title="Digita Movement - Agência Digital">
                    <span>Digital Movement</span>
                    <img src="/assets/logos/digital-movement.svg" alt="Digita Movement - Agência Digital" width="20px" />
                </a>
            </p>
        </div>    
    </div>    
</footer>
